//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgCheckedRadio } from '../icons/CheckedRadio';

export function CheckedRadioIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCheckedRadio} data-qa="CheckedRadioIcon">
      <svg />
    </SvgIcon>
  );
}
